<template>
    <div>
        <!--Шаг 1-->
        <div v-show="numberStep === 1">
            <div class="page__head password-recovery container">
                <div class="page__head-inner block">
                    <div class="password-recovery__steps">
                        <a href="" class="password-recovery__steps-item password-recovery__steps-item--active">1</a><a href="" class="password-recovery__steps-item">2</a><a href="" class="password-recovery__steps-item">3</a><a href="" class="password-recovery__steps-item">4</a><a href="" class="password-recovery__steps-item">5</a><a href="" class="password-recovery__steps-item">6</a>
                    </div>
                    <h1 class="password-recovery__title page__title">Введите проверочный код</h1>
                    <div class="password-recovery__descr big">Мы должны убедиться, что вы не робот</div>
                </div>
            </div>
            <div class="page__main is-offset container">
                <form class="block js-form">
                    <div class="password-recovery__row">
                        <div id="captcha1" class="password-recovery__item capcha-image">
                            <img src="/Captcha/Index">
                        </div>
                        <div class="password-recovery__item txt-input__input">
                            <input type="text"
                                   class="txt-input__field input req"
                                   :class="isCaptchaCorrect==-1 ? 'is-error' : ''"
                                   placeholder="Введите код"
                                   v-model="captchacode">
                            <div class="txt-input__required txt-input__required--error" v-if="isCaptchaCorrect==-1">{{captchaCodeError}}</div>
                        </div>
                        <button type="button"
                                id="buttoncaptcha"
                                class="password-recovery__item password-recovery__item--auto button button--th-main"
                                v-bind:class="{'is-disable':isCaptchaButtonDisabled}"
                                v-on:click="checkCaptcha">
                            <span id="spin_buttoncaptcha"></span>
                            <span class="button__text" id="text_buttoncaptcha">Подтвердить</span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
        <!--Шаг 2-->
        <div v-show="numberStep === 2">
            <div class="page__head password-recovery container">
                <div class="page__head-inner block">
                    <div class="password-recovery__steps">
                        <a href="" class="password-recovery__steps-item password-recovery__steps-item--active">1</a><a href="" class="password-recovery__steps-item password-recovery__steps-item--active">2</a><a href="" class="password-recovery__steps-item">3</a><a href="" class="password-recovery__steps-item">4</a><a href="" class="password-recovery__steps-item">5</a><a href="" class="password-recovery__steps-item">6</a>
                    </div>
                    <h1 class="password-recovery__title page__title">Восстановление доступа</h1>
                    <div class="password-recovery__descr big">Выберите, что вы помните о вашем профиле</div>
                </div>
            </div>
            <div class="page__main is-offset container">
                <div class="block">
                    <div class="password-recovery__row">
                        <a class="password-recovery__choose-block" v-on:click="switchToLogin">
                            <span class="password-recovery__choose-icon">
                                <svg width="90" height="90" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11 84V79.25C11 60.8865 26.2223 46 45 46C63.7777 46 79 60.8865 79 79.25V84" stroke="#0078A8" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                    <path d="M44 46C54.4932 46 63 37.4932 63 27C63 16.5066 54.4932 8 44 8C33.5066 8 25 16.5066 25 27C25 37.4932 33.5066 46 44 46Z" stroke="#0078A8" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                </svg>
                            </span>
                            <span class="password-recovery__choose-name text-lg">
                                Логин
                            </span>
                        </a>
                        <a class="password-recovery__choose-block" v-on:click="switchToEmail">
                            <span class="password-recovery__choose-icon">
                                <svg width="228" height="95" viewBox="0 0 228 95" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="49.5" cy="81.5" r="2.5" stroke="#0078A8" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"></circle>
                                    <rect x="30.25" y="11.25" width="38.5" height="77.5" rx="4.75" stroke="#0078A8" stroke-width="2.5"></rect>
                                    <path d="M40 12H59V15C59 16.1046 58.1046 17 57 17H42C40.8954 17 40 16.1046 40 15V12Z" fill="#0078A8"></path>
                                    <rect class="icon-dark" x="46" y="14" width="5" height="1" rx="0.5" fill="white"></rect>
                                    <rect class="icon-dark" width="1" height="1" rx="0.5" transform="matrix(-1 0 0 1 52.6557 14)" fill="white"></rect>
                                    <path d="M195.112 36.704V43.7692M197.455 84.9748C177.539 90.8613 148.252 84.9748 148.252 53.1859C142.853 -0.392181 226.01 -4.63434 217.37 57.8951C217.37 74.5576 195.112 70.8441 195.112 62.6041V57.8951M195.112 43.7692C184.568 26.1096 168.167 33.1734 168.167 52.0103C168.167 73.8562 189.254 73.2017 195.112 57.8951M195.112 43.7692V57.8951" stroke="#0078A8" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                </svg>
                            </span>
                            <span class="password-recovery__choose-name text-lg">
                                Телефон или почта
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <!--Шаг 3 Телефон и емейл-->
        <div v-show="numberStep === 3">
            <div class="page__head password-recovery container">
                <div class="page__head-inner block">
                    <div class="password-recovery__steps">
                        <a href="" class="password-recovery__steps-item password-recovery__steps-item--active">1</a><a href="" class="password-recovery__steps-item password-recovery__steps-item--active">2</a><a href="" class="password-recovery__steps-item password-recovery__steps-item--active">3</a><a href="" class="password-recovery__steps-item">4</a><a href="" class="password-recovery__steps-item">5</a><a href="" class="password-recovery__steps-item">6</a><a href="" class="password-recovery__steps-item">7</a>
                    </div>
                    <h1 class="password-recovery__title page__title">Введите телефон или почту</h1>
                    <div class="password-recovery__descr big">Отправим логин, по которому вы сможете восстановить пароль</div>
                </div>
            </div>
            <div class="page__main is-offset container">
                <form class="block js-form js-show-blocks-container">
                    <div class="js-hidden-block password-recovery__row-container">
                        <div class="password-recovery__row-label text-lg">
                            Введите e-mail или телефон
                        </div>
                        <div class="password-recovery__row js-only-one-input-container">
                            <div class="password-recovery__item txt-input__input">
                                <input class="txt-input__field input js-only-one-input--one"
                                       autocomplete="on"
                                       v-model="email"
                                       type="email"
                                       placeholder="Введите почту"
                                       data-type="email"
                                       v-bind:disabled="checkPhone">
                                <div class="txt-input__required txt-input__required--error" v-if="email.length > 0 & $v.email.$invalid">Неверно введен e-mail</div>
                            </div>
                            <div class="password-recovery__item txt-input__input">
                                <masked-input type="text"
                                              name="phone"
                                              v-model="phone"
                                              class="txt-input__field input js-only-one-input--two"
                                              :mask="['(', /[9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                                              placeholder="+7 ( )"
                                              :showMask=showMask
                                              v-bind:disabled="email.length !== 0">
                                    data-type="phone">
                                </masked-input>
                                <div class="txt-input__required txt-input__required--error" v-if="checkPhone && $v.phone.$invalid">Неверно введен номер телефона</div>
                            </div>
                            <button type="button"
                                    id="buttonsendcode"
                                    class="password-recovery__item password-recovery__item--auto button button--th-main js-show-block-trigger"
                                    v-bind:class="{'is-disable':isEmailPhoneButtonDisabled}"
                                    v-on:click="sendCode">
                                <span id="spin_emailphone"></span>
                                <span class="button__text" id="text_emailphone">Подтвердить</span>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <!--Шаг 3 Логин-->
        <div v-show="numberStep === 4">
            <div class="page__head password-recovery container">
                <div class="page__head-inner block">
                    <div class="password-recovery__steps">
                        <a href="/password-recovery" class="password-recovery__steps-item password-recovery__steps-item--active">1</a><a href="/password-recovery/step-2.php" class="password-recovery__steps-item password-recovery__steps-item--active">2</a><a href="/password-recovery/step-3.php" class="password-recovery__steps-item password-recovery__steps-item--active">3</a><a href="/password-recovery/step-4.php" class="password-recovery__steps-item">4</a><a href="/password-recovery/step-5.php" class="password-recovery__steps-item">5</a><a href="/password-recovery/step-6.php" class="password-recovery__steps-item">6</a>
                    </div>
                    <h1 class="password-recovery__title page__title">Введите логин для восстановления пароля</h1>
                    <div class="password-recovery__descr big">Мы покажем вам номера, которые были привязаны к вашему логину</div>
                </div>
            </div>
            <div class="page__main is-offset container">
                <form class="block js-form">
                    <div class="password-recovery__row">
                        <div class="password-recovery__item txt-input__input">
                            <input type="text"
                                   class="txt-input__field input req"
                                   :class="isLoginError==-1 ? 'is-error' : ''"
                                   v-model="login"
                                   placeholder="Введите логин">
                            <div class="txt-input__required txt-input__required--error" v-if="isLoginError==-1">{{responseSendLogin}}</div>
                        </div>
                        <button type="button"
                                id="buttonsendlogin"
                                class="password-recovery__item password-recovery__item--auto button button--th-main"
                                v-bind:class="{'is-disable':isLoginButtonDisabled}"
                                v-on:click.prevent="sendLogin">
                            <span id="spin_login"></span>
                            <span class="button__text" id="text_login">Подтвердить</span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
        <!--Шаг 4 Отправка кода-->
        <div v-show="numberStep === 5">
            <div class="page__head password-recovery container">
                <div class="page__head-inner block">
                    <div class="password-recovery__steps">
                        <a href="" class="password-recovery__steps-item password-recovery__steps-item--active">1</a><a href="" class="password-recovery__steps-item password-recovery__steps-item--active">2</a><a href="" class="password-recovery__steps-item password-recovery__steps-item--active">3</a><a href="" class="password-recovery__steps-item password-recovery__steps-item--active">4</a><a href="" class="password-recovery__steps-item password-recovery__steps-item--active">5</a><a href="" class="password-recovery__steps-item">6</a>
                    </div>
                    <h1 class="password-recovery__title page__title">Отправили Вам код</h1>
                    <div class="password-recovery__descr big">Введите проверочный код</div>
                </div>
            </div>
            <div class="page__main is-offset container">
                <form class="block js-form">
                    <div class="password-recovery__row js-timer-container js-trigger-timer-container">
                        <div class="password-recovery__item txt-input__input">
                            <input type="text"
                                   class="txt-input__field input req"
                                   placeholder="Введите проверочный код"
                                   v-model="restoreCodeLogin"
                                   maxlength="4"
                                   ref="LoginRestoreCode">
                            <div class="txt-input__required txt-input__required--error">{{ resposneSendEmailRecoverCode }}</div>
                        </div>
                        <div class="password-recovery__item password-recovery__item--auto">
                            <button type="button"
                                    id="buttonemailrecovercode"
                                    class="button button--th-main js-poison-code-submit"
                                    :class="!isCodeCorrect || isStep5ButtonDisabled ? 'is-disable' : ''"
                                    v-on:click.prevent="sendEmailRecoverCode">
                                <span id="spin_step5"></span>
                                <span class="button__text" id="text_step5">Подтвердить</span>
                            </button>
                            <button type="button" class="button button--th-main js-poison-code js-poison-code-again" style="display: none;" v-on:click.prevent="sendEmailRecoverCode">Отправить повторно</button>
                        </div>
                        <div class="password-recovery__item form-timer js-timer is-show">
                            <svg class="form-timer__svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" fill="#fff">
                                <path stroke-dasharray="204 283" class="form-timer__circle js-timer-circle" d="
						M 50, 50
						m -45, 0
						a 45,45 0 1,0 90,0
						a 45,45 0 1,0 -90,0
						"></path>
                            </svg>
                            <span class="js-timer-count form-timer__count" data-circle-timer-time>{{counter}}</span>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <!--Шаг 5 Получение логинов-->
        <div v-show="numberStep === 6">
            <div class="page__head password-recovery container">
                <div class="page__head-inner block">
                    <div class="password-recovery__steps">
                        <a href="/password-recovery" class="password-recovery__steps-item password-recovery__steps-item--active">1</a><a href="/password-recovery/step-2.php" class="password-recovery__steps-item password-recovery__steps-item--active">2</a><a href="/password-recovery/step-3-2.php" class="password-recovery__steps-item password-recovery__steps-item--active">3</a><a href="/password-recovery/step-4-2.php" class="password-recovery__steps-item password-recovery__steps-item--active">4</a><a href="/password-recovery/step-5-2.php" class="password-recovery__steps-item password-recovery__steps-item--active">5</a><a href="/password-recovery/step-6-2.php" class="password-recovery__steps-item">6</a><a href="/password-recovery/step-7-2.php" class="password-recovery__steps-item">7</a>
                    </div>
                    <h1 class="password-recovery__title page__title">Вам был направлен список логинов</h1>
                    <div class="password-recovery__descr big">Введите логин в поле ниже, чтобы восстановить пароль. Если логинов несколько, то введите тот, для которого необходимо восстановить доступ</div>
                </div>
            </div>
            <div class="page__main is-offset container">
                <form class="block js-form">
                    <div class="password-recovery__row">
                        <div class="password-recovery__item password-recovery__item--lg txt-input__input">
                            <input type="text"
                                   class="txt-input__field input req"
                                   v-model="login"
                                   placeholder="Введите логин">
                            <div class="txt-input__required txt-input__required--error">
                                Текст ошибки для поля
                            </div>
                        </div>
                        <button type="button"
                                id="buttonsendlogin"
                                class="password-recovery__item password-recovery__item--auto button button--th-main"
                                v-bind:class="{'is-disable':isStep6ButtonDisabled}"
                                v-on:click.prevent="sendLogin">
                            <span id="spin_step6"></span>
                            <span class="button__text" id="text_step6">Подтвердить</span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
        <!--Шаг 6 Код на телефон-->
        <div v-show="numberStep === 7">
            <div class="page__head password-recovery container">
                <div class="page__head-inner block">
                    <div class="password-recovery__steps">
                        <a href="/password-recovery" class="password-recovery__steps-item password-recovery__steps-item--active">1</a><a href="/password-recovery/step-2.php" class="password-recovery__steps-item password-recovery__steps-item--active">2</a><a href="/password-recovery/step-3-2.php" class="password-recovery__steps-item password-recovery__steps-item--active">3</a><a href="/password-recovery/step-4-2.php" class="password-recovery__steps-item password-recovery__steps-item--active">4</a><a href="/password-recovery/step-5-2.php" class="password-recovery__steps-item password-recovery__steps-item--active">5</a><a href="/password-recovery/step-6-2.php" class="password-recovery__steps-item password-recovery__steps-item--active">6</a><a href="/password-recovery/step-7-2.php" class="password-recovery__steps-item">7</a>
                    </div>
                    <h1 class="password-recovery__title page__title">Отправили код на Ваш номер</h1>
                    <div class="password-recovery__descr big">Введите проверочный код отправленный на номер, который был привязан к логину</div>
                </div>
            </div>
            <div class="page__main is-offset container">
                <form class="block js-form">
                    <div class="password-recovery__row js-timer-container js-trigger-timer-container">
                        <div class="password-recovery__item txt-input__input">
                            <input type="text"
                                   class="txt-input__field input req"
                                   v-model="restoreCodePassword"
                                   maxlength="4"
                                   placeholder="Введите проверочный код">
                            <div class="txt-input__required txt-input__required--error">{{ responseLoginRestoreCode }}</div>
                        </div>
                        <div class="password-recovery__item password-recovery__item--auto">
                            <button type="button"
                                    id="buttonloginrestorecode"
                                    class="button button--th-main js-poison-code-submit"
                                    :class="!isCodePasswordCorrect || isStep7ButtonDisabled ? 'is-disable' : ''"
                                    v-on:click.prevent="sendLoginRestoreCode">
                                <span id="spin_step7"></span>
                                <span class="button__text" id="text_step7">Подтвердить</span>
                            </button>
                            <button type="button" class="button button--th-main js-poison-code js-poison-code-again" style="display: none;" v-on:click.prevent="sendLoginRestoreCode">Отправить повторно</button>
                        </div>
                        <div class="password-recovery__item form-timer js-timer is-show">
                            <svg class="form-timer__svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" fill="#fff">
                                <path stroke-dasharray="224 283" class="form-timer__circle js-timer-circle" d="
						M 50, 50
						m -45, 0
						a 45,45 0 1,0 90,0
						a 45,45 0 1,0 -90,0
						"></path>
                            </svg>
                            <span class="js-timer-count form-timer__count" data-circle-timer-time>{{counter}}</span>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <!--Шаг 6 Код на емейл-->
        <div v-show="numberStep === 9">
            <div class="page__head password-recovery container">
                <div class="page__head-inner block">
                    <div class="password-recovery__steps">
                        <a href="/password-recovery" class="password-recovery__steps-item password-recovery__steps-item--active">1</a><a href="/password-recovery/step-2.php" class="password-recovery__steps-item password-recovery__steps-item--active">2</a><a href="/password-recovery/step-3-2.php" class="password-recovery__steps-item password-recovery__steps-item--active">3</a><a href="/password-recovery/step-4-2.php" class="password-recovery__steps-item password-recovery__steps-item--active">4</a><a href="/password-recovery/step-5-2.php" class="password-recovery__steps-item password-recovery__steps-item--active">5</a><a href="/password-recovery/step-6-2.php" class="password-recovery__steps-item password-recovery__steps-item--active">6</a><a href="/password-recovery/step-7-2.php" class="password-recovery__steps-item">7</a>
                    </div>
                    <h1 class="password-recovery__title page__title">Отправили код на Ваш емейл</h1>
                    <div class="password-recovery__descr big">Введите проверочный код отправленный на емейл, который был привязан к логину</div>
                </div>
            </div>
            <div class="page__main is-offset container">
                <form class="block js-form">
                    <div class="password-recovery__row js-timer-container js-trigger-timer-container">
                        <div class="password-recovery__item txt-input__input">
                            <input type="text"
                                   class="txt-input__field input req"
                                   v-model="restoreCodePassword"
                                   maxlength="4"
                                   placeholder="Введите проверочный код">
                            <div class="txt-input__required txt-input__required--error">{{ responseLoginRestoreCode }}</div>
                        </div>
                        <div class="password-recovery__item password-recovery__item--auto">
                            <button type="button"
                                    id="buttonloginrestorecode"
                                    class="button button--th-main js-poison-code-submit"
                                    :class="!isCodePasswordCorrect || isStep9ButtonDisabled ? 'is-disable' : ''"
                                    v-on:click.prevent="sendLoginRestoreCode">
                                <span id="spin_step9"></span>
                                <span class="button__text" id="text_step9">Подтвердить</span>
                            </button>
                            <button type="button" class="button button--th-main js-poison-code js-poison-code-again" style="display: none;" v-on:click.prevent="sendLoginRestoreCode">Отправить повторно</button>
                        </div>
                        <div class="password-recovery__item form-timer js-timer is-show">
                            <svg class="form-timer__svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" fill="#fff">
                                <path stroke-dasharray="224 283" class="form-timer__circle js-timer-circle" d="
						M 50, 50
						m -45, 0
						a 45,45 0 1,0 90,0
						a 45,45 0 1,0 -90,0
						"></path>
                            </svg>
                            <span class="js-timer-count form-timer__count" data-circle-timer-time>{{counter}}</span>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <!--Шаг 7 Новый пароль-->
        <div v-show="numberStep === 8">
            <div class="page__head password-recovery container">
                <div class="page__head-inner block">
                    <div class="password-recovery__steps">
                        <a href="/password-recovery" class="password-recovery__steps-item password-recovery__steps-item--active">1</a><a href="/password-recovery/step-2.php" class="password-recovery__steps-item password-recovery__steps-item--active">2</a><a href="/password-recovery/step-3-2.php" class="password-recovery__steps-item password-recovery__steps-item--active">3</a><a href="/password-recovery/step-4-2.php" class="password-recovery__steps-item password-recovery__steps-item--active">4</a><a href="/password-recovery/step-5-2.php" class="password-recovery__steps-item password-recovery__steps-item--active">5</a><a href="/password-recovery/step-6-2.php" class="password-recovery__steps-item password-recovery__steps-item--active">6</a><a href="/password-recovery/step-7-2.php" class="password-recovery__steps-item password-recovery__steps-item--active">7</a>
                    </div>
                    <h1 class="password-recovery__title page__title">Придумайте новый пароль</h1>
                    <div class="password-recovery__descr big">Пароль должен содержать как минимум одну строчную и прописную букву, а также специальные символы. Длина пароля не менее 8 символов</div>
                </div>
            </div>
            <div class="page__main is-offset js-password-recovery-form password-recovery-form container">
                <div class="password-recovery-form__wrapper">
                    <form class="block js-form">
                        <div class="password-recovery__row js-timer-container js-trigger-timer-container">
                            <div class="password-recovery__item">
                                <label class="txt-input js-psw-parent">
                                    <div class="txt-input--tip">
                                        <div class="txt-input__input">
                                            <input class="txt-input__field input req js-psw-input"
                                                   data-input-placeholder=""
                                                   ref="FocusPassword"
                                                   name="password"
                                                   type="password"
                                                   v-model="password"
                                                   autocomplete="off"
                                                   placeholder="Пароль">
                                            <div class="txt-input__ctrl">
                                                <div class="button-icon js-show-password"><i class="icon icon--view"></i></div>
                                            </div>
                                            <div class="txt-input__required txt-input__required--error">Пароль не соответствует требованиям, выделенным красным цветом выше</div>
                                        </div>
                                        <div class="txt-input__tip">
                                            <div class="help">
                                                <div class="help__drop js-message-drop">
                                                    <div class="help__inner">
                                                        <span>Для защиты ваших данных необходимо придумать безопасный пароль. <br>Он должен содержать:</span> <br>
                                                        <span class="status-error js-message-length">8 и более символов</span> <br>
                                                        <span class="status-error js-message-capital">Прописные буквы [A-Z]</span> <br>
                                                        <span class="status-error js-message-letter">Строчные буквы [a-z]</span> <br>
                                                        <span class="status-error js-message-symbol">Специальные символы [!@#$%^&amp;*()_+.]</span> <br>
                                                        <span class="status-error js-message-number">Цифры</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </label>
                            </div>
                            <div class="password-recovery__item">
                                <label class="txt-input js-psw-parent">
                                    <div class="txt-input__input">
                                        <input class="txt-input__field input req js-psw-input js-psw-repeat"
                                               :class="this.$v.confirmPassword.$invalid && password != '' ? 'is-error' : ''"
                                               data-input-placeholder=""
                                               type="password"
                                               v-model="confirmPassword"
                                               autocomplete="off"
                                               placeholder="Повторите пароль">
                                        <div class="txt-input__ctrl">
                                            <div class="button-icon js-show-password"><i class="icon icon--view"></i></div>
                                        </div>
                                        <div class="txt-input__required txt-input__required--error">{{confirmPasswordTypeText}}</div>
                                    </div>
                                    <div class="txt-input__tip">
                                        <div class="help">
                                            <div class="help__drop js-message-drop">
                                                <div class="help__inner">
                                                    <span>Для защиты ваших данных необходимо придумать безопасный пароль. <br>Он должен содержать:</span> <br>
                                                    <span class="status-error js-message-length">8 и более символов</span> <br>
                                                    <span class="status-error js-message-capital">Прописные буквы [A-Z]</span> <br>
                                                    <span class="status-error js-message-letter">Строчные буквы [a-z]</span> <br>
                                                    <span class="status-error js-message-symbol">Специальные символы [!@#$%^&amp;*()_+.]</span> <br>
                                                    <span class="status-error js-message-number">Цифры</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </label>
                            </div>
                            <button type="button"
                                    id="buttonSave"
                                    class="password-recovery__item password-recovery__item--auto button button--th-main js-poison-code-submit"
                                    :class="(this.$v.password.$invalid || this.$v.confirmPassword.$invalid) ? 'is-disable' : ''"
                                    v-on:click.prevent="sendResetPassword">
                                Сохранить пароль
                            </button>
                            <button type="button"
                                    id="buttonEnter"
                                    class="password-recovery__item password-recovery__item--auto button button--th-main js-poison-code-submit"
                                    style="display:none;"
                                    v-on:click.prevent="forceInvokeLoginWindow">
                                Войти
                            </button>
                        </div>
                    </form>
                    <div id="infoSuccess" class="alert-container password-recovery-form-alert js-password-recovery-form-alert block is-show" style="display:none;">
                        <div class="alert alert--info">
                            Новый пароль успешно сохранён
                        </div>
                    </div>
                </div>
            </div>
            <!--<span class="password-reset-block" style="text-align: center; margin-top: 24px; margin-left: 10px">
                {{ responseResetPassword }}
            </span>-->
        </div>
    </div>
</template>


<script>
    import Vue from "vue";
    import Vuelidate from 'vuelidate'
    Vue.use(Vuelidate)
    import { required, sameAs, minLength, email, maxLength } from 'vuelidate/lib/validators'
    import Recaptcha from './Recaptcha.vue'
    import MaskedInput from 'vue-text-mask'

    export default {
        components: {
            "recaptcha": Recaptcha,
            "masked-input": MaskedInput
        },
        props: {
            sitekey: String
        },
        data: () => ({
            successfulCompletion: false,
            lifeTimeRestoreCode: 300,
            counter: 100,
            showMask: true,
            isLogin: true,
            restoreCodeLogin: null,
            restoreCodePassword: null,
            captchacode: "",
            captchacode2: "",
            email: "",
            phone: "",
            emailPhone: {},
            login: "",
            password: null,
            confirmPassword: null,
            responseSendEmail: "",
            resposneSendEmailRecoverCode: "",
            responseSendLogin: "",
            responseLoginRestoreCode: "",
            responseLoginRestoreToken: "",
            responseResetPassword: "",
            responseFlag: false,
            numberStep: 1,
            countCheck: 1,
            isLoginError: 0,
            isCaptchaCorrect: 0,
            captchaCodeError: '',
            captchaCodeError2: '',
            isSuccessfully: false,
            validateRecaptcha: false,
            sendingRequest: false,
            sourse: "",
            isCaptchaButtonDisabled: false,
            isEmailPhoneButtonDisabled: false,
            isStep5ButtonDisabled: false,
            isStep6ButtonDisabled: false,
            isStep7ButtonDisabled: false,
            isStep9ButtonDisabled: false,
            isLoginButtonDisabled: false
        }),
        computed: {
            isCodeCorrect: function () {
                if (this.restoreCodeLogin) {
                    if (this.restoreCodeLogin.length == 4) {
                        return true;
                    }
                    return false;
                }
            },
            isCodePasswordCorrect: function () {
                if (this.restoreCodePassword) {
                    if (this.restoreCodePassword.length == 4) {
                        return true;
                    }
                    return false;
                }
            },
            getSuccessfulCompletion: function () {
                return this.successfulCompletion;
            },
            getIsLogin: function () {
                return this.isLogin;
            },
            confirmPasswordTypeText: function () {
                return this.$v.confirmPassword.$invalid && this.password != '' ? 'Пароли должны совпадать' : '';
            },
            getSourse: function () {
                if (this.email == null || this.email == "") {
                    this.sourse = this.phone;
                    return this.sourse
                }
                else {
                    this.sourse = this.email;
                    return this.sourse
                }
            },
            getSendingRequest: function () {
                return this.sendingRequest
            },
            getEmailPhone: function () {
                if (this.email.length) {
                    this.emailPhone.email = this.email;
                }
                else this.emailPhone.email = null

                return this.emailPhone;
            },
            checkPhone: function () {
                if (this.phone.length > 0) {
                    let result = this.phone.replace(/[^+\d]/g, "")

                    if (result.length > 0) {
                        this.emailPhone.phone = "7" + result
                        return true
                    }
                    this.emailPhone.phone = null
                }
                return false
            },
            getRestoreCode: function () {
                if (this.restoreCodeLogin !== null) return this.restoreCodeLogin;
                if (this.restoreCodePassword !== null) return this.restoreCodePassword;
                return null
            },
            getRestoreCodePassword: function () {
                if (this.restoreCodePassword !== null) return this.restoreCodePassword;
                return null
            },
            getLogin: function () {
                return this.login;
            },
            getCode: function () {
                return this.responseLoginRestoreToken;
            },
            getSuccessfully: function () {
                return this.isSuccessfully;
            },
        },
        methods: {
            runSpinButton: function (spinId, textId) {
                // show spin start
                var target = document.getElementById(spinId);

                var opts = {
                    lines: 14, // число линий для отрисоки
                    length: 25, // длинна каждой линии
                    width: 10, // ширина линий
                    radius: 36, // радиус внутреннего круга
                    corners: 1, // радиус скругления границ
                    rotate: 0, // поворот
                    scale: 0.2, // масштаб
                    direction: 1, // направление движения: 1: по часовой, -1: против часовой
                    color: '#fff', // цвет: #rgb или #rrggbb или массив цветов
                    speed: 0.6, // скорость вращения
                    trail: 56, // процент скорости затухания
                    hwaccel: false, // аппаратное ускорение
                    className: 'spinner', // дополнительный CSS-класс
                    zIndex: 2e9, // z-index (вплоть до 2000000000)
                    top: '50%', // отступ сверху
                    left: '50%' // отступ слева
                };

                new Spinner(opts).spin(target);
                // show spin end

                var text = document.getElementById(textId);
                target.style.display = 'flex';
                text.style.display = 'none';
            },

            stopSpinButton: function (spinId, textId) {
                var target = document.getElementById(spinId);
                var text = document.getElementById(textId);
                target.style.display = 'none';
                text.style.display = 'flex';
            },

            showCaptcha: function () {
                document.querySelector(".js-hidden-block").style.display = 'none';
                document.querySelector(".js-shown-block").style.display = '';

            },
            getRandomInt: function (min, max) {
                min = Math.ceil(min);
                max = Math.floor(max);
                return Math.floor(Math.random() * (max - min) + min);
            },
            checkCaptcha: function (event) {
                event.stopPropagation();

                const self = this;

                var idSpin = 'spin_buttoncaptcha';
                var idButtonSpan = 'text_buttoncaptcha';
                self.runSpinButton(idSpin, idButtonSpan);
                const input = document.querySelector('.js-capcha-input');
                const button = document.getElementById("buttoncaptcha");
                var count = this.getRandomInt(0, 100);
                self.isCaptchaButtonDisabled = true;

                axios.post('/Register/CheckCaptcha/' + self.captchacode)
                    .then(function (response) {
                        if (response.data.isSuccess) {
                            self.numberStep = 2;
                            self.stopSpinButton(idSpin, idButtonSpan);
                        }
                        if (!response.data.isSuccess) {
                            var countch = self.countCheck++;

                            if (countch % 2 === 0) {
                                var str = '<img src="/Captcha/Index/' + count + '">';
                                $("#captcha1").html(str);
                            }
                            self.captchaCodeError = response.data.message.join();
                            self.isCaptchaCorrect = -1;
                            self.isCaptchaButtonDisabled = false;
                            self.stopSpinButton(idSpin, idButtonSpan);
                        }
                    })
                    .catch(function (error) {
                        self.isValidateErrors = true;
                        self.isServerVerify = false;
                        self.phoneVerifyError = 'Верификация телефона невозможна, попробуйте позже';
                        $("#phone").prop('disabled', '');
                        self.stopSpinButton(idSpin, idButtonSpan);
                        self.isCaptchaButtonDisabled = false;
                    });
            },
            sendCode() {
                this.getSourse;
                this.isEmailPhoneButtonDisabled = true;
                var idSpin = 'spin_emailphone';
                var idButtonSpan = 'text_emailphone';
                this.runSpinButton(idSpin, idButtonSpan);

                recoverLogin(this.getEmailPhone.email, this.getEmailPhone.phone, this.getRestoreCode).then(result => {
                    this.responseSendEmail = result.responseText;
                    if (result.isSuccess) {
                        this.counter = this.lifeTimeRestoreCode;
                        this.countdown();
                        this.$nextTick(() => this.setFocusLoginRestoreCode());
                        this.numberStep = 5;
                        this.stopSpinButton(idSpin, idButtonSpan);

                    }
                }).finally(() => {
                    this.sendRequest();
                });
            },
            sendRecoverCode: function () {
                this.sendRequest();
                recoverLogin(this.getEmailPhone.email, this.getEmailPhone.phone, this.getRestoreCode).then(result => {
                    this.resposneSendEmailRecoverCode = result.responseText;
                    if (result.isSuccess) {
                        this.numberStep = 6;
                        this.successfulCompletion = true;
                    }
                });
                this.sendRequest();
            },
            switchToLogin() {
                this.numberStep = 4;
            },
            switchToEmail() {
                this.numberStep = 3;
            },
            sendRequest: function () {
                this.sendingRequest = !this.sendingRequest
            },
            forceInvokeLoginWindow: function () {
                invokeLoginWindow()
            },
            countdown: function () {
                var self = this;
                setTimeout(function () {
                    //if (self.getSuccessfulCompletion) {
                    //    return;
                    //}
                    if (self.counter <= 1) {
                        self.endLifeRestoreCode();
                        self.numberStep = 2;
                        self.responseSendEmail = "Истекло время кода подтверждения, пожалуйста, попробуйте с начала еще раз"
                        self.responseSendLogin = "Истекло время кода подтверждения, пожалуйста, попробуйте с начала еще раз"
                    } else {
                        self.counter--;
                        self.countdown();
                    }
                },
                    1000);
            },
            setFocusPasswordRestoreCode() {
                this.$refs.PasswordRestoreCode.focus();
            },
            setFocusLoginRestoreCode() {
                this.$refs.LoginRestoreCode.focus();
            },
            setFocusPassword() {
                this.$refs.FocusPassword.focus();
            },
            runRecaptchaEmail() {
                this.sendRequest();
                this.$refs.rec.$refs.recaptcha.execute()
            },
            runRecaptchaLogin() {
                this.sendRequest();
                this.$refs.recs.$refs.recaptcha.execute()
            },
            sendEmail(success) {
                if (success) {
                    recoverLogin(this.getEmailPhone.email, this.getEmailPhone.phone, this.getRestoreCode).then(result => {
                        this.responseSendEmail = result.responseText;
                        if (result.isSuccess) {
                            this.numberStep = 3;
                            this.counter = this.lifeTimeRestoreCode;
                            this.countdown();
                            this.$nextTick(() => this.setFocusLoginRestoreCode());
                        }
                    }).finally(() => {
                        this.sendRequest();
                        this.$refs.rec.$refs.recaptcha.reset()
                    });
                } else {
                    this.responseSendEmail = "Проверка Recaptcha не пройдена"
                    this.sendRequest();
                    this.$refs.rec.$refs.recaptcha.reset()
                }

            },
            sendEmailRecoverCode: function () {
                this.isStep5ButtonDisabled = true;
                var idSpin = 'spin_step5';
                var idButtonSpan = 'text_step5';
                this.runSpinButton(idSpin, idButtonSpan);
                this.sendRequest();
                recoverLogin(this.getEmailPhone.email, this.getEmailPhone.phone, this.getRestoreCode).then(result => {
                    this.resposneSendEmailRecoverCode = result.responseText;
                    if (result.isSuccess) {
                        this.numberStep = 6;
                        this.successfulCompletion = false;
                        this.stopSpinButton(idSpin, idButtonSpan);
                    }
                    else {
                        this.isStep5ButtonDisabled = false;
                        this.stopSpinButton(idSpin, idButtonSpan);
                    }
                });
                this.sendRequest();
            },
            sendLogin() {
                var idSpin = 'spin_step6';
                var idButtonSpan = 'text_step6';
                if (this.numberStep == 6) {
                    this.isStep6ButtonDisabled = true;
                    this.runSpinButton(idSpin, idButtonSpan);
                }
                if (this.numberStep == 4) {
                    idSpin = 'spin_login';
                    idButtonSpan = 'text_login';
                    this.isLoginButtonDisabled = true;
                    this.runSpinButton(idSpin, idButtonSpan);
                }
                this.getSourse;
                forgotPassword(this.getLogin).then(result => {
                    this.responseSendLogin = result.responseText;
                    if (result.isSuccess) {
                        this.counter = this.lifeTimeRestoreCode;
                        this.countdown();
                        this.$nextTick(() => this.setFocusPasswordRestoreCode());
                        if (result.responseText == "На указанный номер телефона отправлено смс сообщение с кодом подтверждения") {
                            this.numberStep = 7;
                            this.stopSpinButton(idSpin, idButtonSpan);
                        }
                        else {
                            this.numberStep = 9;
                            this.stopSpinButton(idSpin, idButtonSpan);
                        }
                    }
                    else {
                        this.isLoginError = -1;
                        this.isStep6ButtonDisabled = false;
                        this.isLoginButtonDisabled = false;
                        this.stopSpinButton(idSpin, idButtonSpan);
                    }
                }).finally(() => {
                    this.sendRequest();
                });
            },
            sendLoginRestoreCode() {
                var idSpin = 'spin_step7';
                var idButtonSpan = 'text_step7';
                if (this.numberStep == 7) {
                    this.isStep7ButtonDisabled = true;
                    this.runSpinButton(idSpin, idButtonSpan);
                }
                if (this.numberStep == 9) {
                    this.isStep9ButtonDisabled = true;
                    idSpin = 'spin_step9';
                    idButtonSpan = 'text_step9';
                    this.runSpinButton(idSpin, idButtonSpan);
                }

                this.sendRequest();
                forgotPassword(this.getLogin, this.getRestoreCodePassword).then(result => {
                    if (result.isSuccess) {
                        this.counter = this.lifeTimeRestoreCode;
                        this.countdown();
                        this.numberStep = 8;
                        this.responseLoginRestoreToken = result.responseText;
                        this.$nextTick(() => this.setFocusPassword());
                        this.stopSpinButton(idSpin, idButtonSpan);
                    }

                    if (!result.isSuccess) {
                        this.responseLoginRestoreToken = result.responseText;
                        this.isStep7ButtonDisabled = false;
                        this.isStep9ButtonDisabled = false;
                        this.stopSpinButton(idSpin, idButtonSpan);
                    }
                });
                this.sendRequest();
            },
            sendResetPassword: function () {
                const saveButton = document.getElementById("buttonSave");
                const enterButton = document.getElementById("buttonEnter");
                const info = document.getElementById("infoSuccess");

                this.sendRequest();
                forgotPassword(this.getLogin, this.getRestoreCodePassword)
                    .then(result => {
                        if (result.isSuccess) {
                            saveButton.style.display = 'none';
                            enterButton.style.display = '';
                            info.style.display = '';
                            resetPassword(this.getLogin,
                                this.password,
                                this.confirmPassword,
                                this.getCode).then(result => {
                                    this.responseResetPassword = result.responseText;
                                    if (result.isSuccess) {
                                        this.responseFlag = true;
                                        this.successfulCompletion = true;
                                        setTimeout(invokeLoginWindow, 5000);
                                    }
                                });
                            //this.forceInvokeLoginWindow();
                        }
                        else this.responseResetPassword = "Истекло время кода подтверждения, пожалуйста, попробуйте с начала еще раз"
                    }
                    )
                this.sendRequest();

            },
            endLifeRestoreCode() {
                this.successfulCompletion = false;
                this.responseFlag = true;
                this.restoreCodeLogin = null;
                this.restoreCodePassword = null;
                this.password = null;
                this.confirmPassword = null;
                this.responseSendEmail = "";
                this.resposneSendEmailRecoverCode = "";
                this.responseSendLogin = "";
                this.responseLoginRestoreCode = "";
                this.responseLoginRestoreToken = "";
                this.responseResetPassword = "";
                this.numberStep = 2;
                this.isSuccessfully = false;
                this.validateRecaptcha = false;
                this.sendingRequest = false;
            },
            zeroing() {
                this.successfulCompletion = false;
                this.responseFlag = true;
                this.restoreCodeLogin = null;
                this.restoreCodePassword = null;
                this.email = "";
                this.phone = "";
                this.login = "";
                this.password = null;
                this.confirmPassword = null;
                this.responseSendEmail = "";
                this.resposneSendEmailRecoverCode = "";
                this.responseSendLogin = "";
                this.responseLoginRestoreCode = "";
                this.responseLoginRestoreToken = "";
                this.responseResetPassword = "";
                this.numberStep = 2;
                this.isSuccessfully = false;
                this.validateRecaptcha = false;
                this.sendingRequest = false;
            }

        },

        validations: {
            password: {
                required,
                minLength: minLength(8),
                validFormat: val => /[A-Z]+/.test(val) &&
                    /[a-z]+/.test(val) &&
                    /[!@#$%^&*()_+.]+/.test(val) &&
                    /[0-9]+/.test(val)
            },
            confirmPassword: {
                //required,
                //minLength: minLength(8),
                //validFormat: val => /[A-ZА-Я]+/.test(val) &&
                //    /[a-zа-я]+/.test(val) &&
                //    /[!@#$%^&*()_+.]+/.test(val) &&
                //    /[0-9]+/.test(val),
                //sameAsPassword: sameAs('password')
                sameAsconfirmPassword: sameAs('password')
            },
            email: {
                email
            },
            phone: {
                validFormat: val => /\(\d{3}\)\s\d{3}-\d{2}\d{2}/.test(val)
            },
            restoreCodeLogin: {
                minLength: minLength(4),
                maxLength: maxLength(4),
                validFormat: val => /[0-9]+/.test(val)
            },
            restoreCodePassword: {
                minLength: minLength(4),
                maxLength: maxLength(4),
                validFormat: val => /[0-9]+/.test(val)
            }
        }
    }

    async function recoverLogin(email, phone, restoreCode) {
        let responseText;
        let isSuccess;
        let result = { responseText, isSuccess };
        await axios.post("/auth/api/users/RecoverLogin",
            {
                Email: email,
                PhoneNumber: phone,
                RestoreCode: restoreCode
            })
            .then(response => { result.responseText = response.data; result.isSuccess = true })
            .catch(error => { result.responseText = error.response.data; result.isSuccess = false });
        return result;
    };

    async function forgotPassword(login, restoreCode) {
        let responseText;
        let isSuccess;
        let result = { responseText, isSuccess };
        await axios.post("/auth/api/users/ForgotPassword",
            {
                Login: login,
                RestoreCode: restoreCode
            })
            .then(response => { result.responseText = response.data; result.isSuccess = true; })
            .catch(error => { result.responseText = error.response.data; result.isSuccess = false });
        return result;
    };

    async function resetPassword(login, password, confirmPassword, code) {
        let responseText;
        let isSuccess;
        let result = { responseText, isSuccess };
        await axios.post("/auth/api/users/ResetPassword",
            {
                Login: login,
                Password: password,
                ConfirmPassword: confirmPassword,
                Code: code
            })
            .then(response => { result.responseText = response.data; result.isSuccess = true })
            .catch(error => { result.responseText = error.response.data; result.isSuccess = false });
        return result;
    }
    function invokeLoginWindow() {
        $("#modalLogin").addClass("is-open")
    }
</script>
<style>
    .error-block {
        position: relative;
        top: 10px !important;
    }

    .password-reset-block {
        display: block;
        color: #287f23;
    }
</style>



// WEBPACK FOOTER //
// Scripts/app/PasswordReset/PasswordReset.vue